import SEOJsonLd from '../../components/feature/SEOJsonLd';
import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import ConsultationSection from './components/ConsultationSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main>
      <SEOJsonLd />
      <NavBar />
      <HeroSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <PricingSection />
      <ConsultationSection />
      <FooterSection />
    </main>
  );
}
